// Component Name:  Miniwidget component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Description:
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version

// Edited by Lavanya
// included widgetClick, totalCount, rateChange
// [21-05-2025] included image support

import React, { Component } from "react";
import { Col, Card, CardBody, Media } from "reactstrap";
import { lkGray2 } from "../Utility/styleComponents";
/**
 *
 * @param {Array<Object>} reports - Array of card objects to be displayed.
 *
 * Each report object can have the following properties:
 *
 * @param {string} title - Title text shown on the card.
 * @param {string} [theme='text-primary'] - Optional theme class for the icon color.
 * @param {string} value - Main value displayed on the card (e.g., "1").
 * @param {string} [totalCount] - Optional total count to show value out of (e.g., "1/10").
 *
 *  either of this not both
 *  @param {string} icon - Icon to display on the card.
 *  @param {image} image - Image to display on the card.
 * 
 * Interactivity:(optional)
 * @param {function} [WidgetClick] - If provided, makes the card clickable. Adds hover effects and changes text color to blue.
 *
 * Footer (optional):
 * The footer is only rendered if `rate` is provided.
 *
 * @param {string} rate - Numeric or percentage change shown in the footer.
 * @param {string} rateChange - Direction of change: must be either `'up'` or `'down'`.
 * @param {string} desc - Description or label explaining the rate.
 */

class MiniWidgets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHoverEffect: false,
    };
  }
  componentDidMount() {
    console.log("miniwidgets: ", this.props.reports);
  }

  getClassTheme = (theme) => {
    if (theme == null) return "text-primary";
    else return theme;
  };
  render() {
    return (
      <React.Fragment>
        {this.props?.reports?.map((report, key) => (
          <Col key={key} md={4}>
            <Card
              onClick={report?.WidgetClick}
              onMouseOver={() => report?.WidgetClick && this.setState({ cardHoverEffect: true })}
              onMouseLeave={() => report?.WidgetClick && this.setState({ cardHoverEffect: false })}
              style={{ cursor: report?.WidgetClick && "pointer", backgroundColor: this.state.cardHoverEffect && report?.WidgetClick && "#EFEFEF" }}
            >
              <CardBody>
                <Media>
                  <Media body className="overflow-hidden">
                    <p className={`text-truncate font-size-14 mb-2  ${report?.WidgetClick && "text-primary"}`} style={{ textDecoration: report?.WidgetClick && "underline" }}>
                      {report.title}
                    </p>
                    <h4 className={`mb-0  ${report?.WidgetClick && "text-primary"}`}>
                      {report.value}
                      {report?.totalCount && <span style={{ color: lkGray2, fontSize: 12 }}>{` / ${report?.totalCount}`}</span>}
                    </h4>
                  </Media>

                  <div className={this.getClassTheme(report.theme)}>
                    {report?.image ? (
                      <img src={report?.image} alt="icon" style={{ width: 25, height: 25 }} />
                    ) : (
                      <i className={report.icon + " font-size-24"} style={{ color: this.props.clr }}></i>
                    )}
                  </div>
                </Media>
              </CardBody>

              {report?.rate && (
                <CardBody className="border-top py-3">
                  <div className="text-truncate">
                    {report.rateChange === "down" ? (
                      <span className="badge badge-soft-danger font-size-11 mr-1">
                        <i className="mdi mdi-menu-down"> </i> {report.rate}
                      </span>
                    ) : (
                      <span className="badge badge-soft-success font-size-11 mr-1">
                        <i className="mdi mdi-menu-up"> </i> {report.rate}
                      </span>
                    )}

                    <span className="text-muted ml-2">{report.desc}</span>
                  </div>
                </CardBody>
              )}
            </Card>
          </Col>
        ))}
      </React.Fragment>
    );
  }
}

export default MiniWidgets;
